import React, { useState, useEffect, useCallback } from "react";

const MtvComponentHook = ({ sessionId, email, event_id }) => {
  //const [sid, setSid] = useState("");

  const setupMtv = useCallback(
    async (pSessionId) => {
      console.log("setupMtv");
      let session_id = pSessionId;
      window.mtvApp.setup({
        id: "mtv-container",
        play_sid: session_id,
        path: "https://d3klq1qh6r64da.cloudfront.net/api_uploads/mtv-master/jme/",
        base_api: "api-lb.virtual-meeting.net",
        event_id: event_id,
      });
    },
    [event_id]
  );

  useEffect(() => {
    (async () => {
      if (sessionId) setupMtv(sessionId);
    })();
    return () => {
      window?.mtvApp?.destroy();
    };
  }, [sessionId, setupMtv]);
  return <div id="mtv-container" className="container"></div>;
};

export default MtvComponentHook;
